import { Component } from '@angular/core';
import { AuthService } from '../../../core/services/auth/auth';
import { Router } from '@angular/router';

@Component({
  selector: 'app-not-allowed',
  imports: [],
  templateUrl: './not-allowed.html',
  styleUrl: './not-allowed.scss',
})
export class NotAllowed {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  logout() {
    this.authService.logout();
    this.router.navigate(['']);
  }
}
